<template>
  <!-- PAGE : PREMIUM-->
  <div class="page text-center mb-7">
    <div v-if="new Date() < new Date('2026-08-01')" class="mb-4"> <!-- Banner promo Summer 2026 -->
      <img src="assets/img/special/banner-summer26.png" class="d-none d-lg-inline" alt="Offre promo Summer 2026" width="1470" height="156">
      <img src="assets/img/special/banner-summer26-sm.png" class="d-lg-none" alt="Offre promo Summer 2026" width="690" height="275">
    </div>
    <div class="text-center mb-5">
      <div class="btn-group btn-group-toggle">
        <label class="btn btn-round btn-outline-secondary" :class="{ active: planPeriod == 'yearly' }">
          <input v-model="planPeriod" type="radio" value="yearly" autocomplete="off">
          {{ printLang("Pricing.Annual") }} <br>
          <span class="text-success">{{ printLang("Pricing.Offer") }}</span>
        </label>
        <label :class="{ active: planPeriod == 'monthly' }" class="btn btn-round btn-outline-secondary d-flex align-items-center">
          <input v-model="planPeriod" type="radio" value="monthly" autocomplete="off">
          {{ printLang("Pricing.Monthly") }}
        </label>
      </div>
    </div>

    <!--REGULAR OFFERS-->
    <div class="col-md-12">
      <div class="row" style="line-height: 1.3em">
        <!-- TEAM -->
        <div class="col-xl-4 col-lg-6 col-12 mt-2 mb-4">
          <div class="pricing-1 h-100 d-flex flex-column">
            <div class="p-4 text-left text-white bg-team">
              <div class="h4 text-uppercase font-weight-bold">{{ printLang("Pricing.Team") }}</div>
              {{ printLang("Pricing.TeamSubtitle") }}
            </div>
            <div class="pricing-1-content border-team pt-5">
              <div class="price">
                <div class="price-container">
                  <h4 class="mt-3 mx-3 text-dark">
                    {{ planPeriod == 'yearly' ? '12,90€' : '15,50€' }}
                    <span style="font-size: initial;">HT / utilisateur</span>
                  </h4>
                </div>
              </div>
              <p>{{ planPeriod == 'yearly' ? 'Facturé annuellement' : 'Sans engagement de durée' }}</p>
              <form class="mb-4" @submit.prevent="sendDataCheckout($event.target)">
                <div class="mb-2 p-3" style="line-height: 46px;">
                  <select v-model="quantityUsersTeam" name="users" class="form-control form-control-lg">
                    <option v-for="nbUsers in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 20, 30, 40, 50, 75, 100]" :key="nbUsers" :value="nbUsers">
                      {{ `${nbUsers} ${nbUsers == 1 ? printLang("Pricing.User") : printLang("Pricing.Users") }` }}
                    </option>
                  </select>
                </div>
                <input type="hidden" name="plan" :value="planPeriod == 'yearly' ? 'team12m' : 'team'">
                <input v-if="couponIsAvailable" type="hidden" name="coupon" :value="coupon">
                <button type="submit" class="btn btn-primary btn-cta btn-tada w-200" style="align-self: center">Choisir</button>
              </form>
              <div v-if="couponIsAvailable" class="m-2 mt-6" style="align-self: center;">
                <form class="form-inline" style="font-size: smaller;" @submit.prevent="$emit('set-coupon', couponInput); couponInput = ''">
                  Code promo : <input v-model="couponInput" type="text" class="mx-2 form-control input-sm" style="width: 90px;" required>
                  <input class="btn btn-outline-primary btn-sm" type="submit" value="Activer">
                  <div v-if="hasValidCoupon" class="text-success" style="font-size: initial;"><b>Activé : {{ coupon }}</b></div>
                  <div v-else-if="coupon" class="text-danger">
                    <template v-if="coupon == 'BLACKFRIDAY' && planPeriod !== 'yearly'">Code réservé aux abonnements annuels</template>
                    <template v-else>Code promo invalide</template>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- BUSINESS -->
        <div class="col-xl-4 col-lg-6 col-12 mt-2 mb-4">
          <div class="pricing-1 popular d-flex flex-column" style="height: 100%">
            <div class="p-4 text-left text-white bg-business">
              <div class="h4 text-uppercase font-weight-bold">{{ printLang("Pricing.Business") }}</div>
              {{ printLang("Pricing.BusinessSubtitle") }}
            </div>
            <div class="pricing-1-content border-business pt-5">
              <div class="price">
                <div class="price-container">
                  <h4 class="mt-3 mx-3 text-dark">
                    {{ planPeriod == 'yearly' ? '24,90€' : '29,90€' }}
                    <span style="font-size: initial;">HT / utilisateur</span>
                  </h4>
                </div>
              </div>
              <p>{{ planPeriod == 'yearly' ? 'Facturé annuellement' : 'Sans engagement de durée' }}</p>
              <form class="mb-4" @submit.prevent="sendDataCheckout($event.target)">
                <div class="mb-2 p-3" style="line-height: 46px;">
                  <select v-model="quantityUsersBusiness" name="users" class="form-control form-control-lg">
                    <option v-for="nbUsers in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 20, 30, 40, 50, 75, 100]" :key="nbUsers" :value="nbUsers">
                      {{ `${nbUsers} ${nbUsers == 1 ? printLang("Pricing.User") : printLang("Pricing.Users") }` }}
                    </option>
                  </select>
                </div>
                <input type="hidden" name="plan" :value="planPeriod == 'yearly' ? 'business12m' : 'business'">
                <input v-if="couponIsAvailable" type="hidden" name="coupon" :value="coupon">
                <button type="submit" class="btn btn-success btn-cta btn-tada w-200" style="align-self: center">Choisir</button>
              </form>
              <div v-if="couponIsAvailable" class="m-2 mt-6" style="align-self: center;">
                <form class="form-inline" style="font-size: smaller;" @submit.prevent="$emit('set-coupon', couponInputBusiness); couponInputBusiness = ''">
                  Code promo : <input v-model="couponInputBusiness" type="text" class="mx-2 form-control input-sm" style="width: 90px;" required>
                  <input class="btn btn-outline-success btn-sm" type="submit" value="Activer">
                  <div v-if="hasValidCoupon" class="text-success" style="font-size: initial;"><b>Activé : {{ coupon }}</b></div>
                  <div v-else-if="coupon" class="text-danger">
                    <template v-if="coupon == 'BLACKFRIDAY' && planPeriod !== 'yearly'">Code réservé aux abonnements annuels</template>
                    <template v-else>Code promo invalide</template>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-4 col-lg-6 col-12 mt-2 mb-4">
          <div class="pricing-1 h-100 d-flex flex-column">
            <div class="p-4 text-left text-white bg-enterprise">
              <div class="h4 text-white text-uppercase font-weight-bold">{{ printLang("Pricing.Enterprise") }}</div>
              {{ printLang("Pricing.EnterpriseSubtitle") }}
            </div>
            <div class="pricing-1-content border-enterprise pt-5">
              <div class="price">
                <div class="price-container text-dark">
                  <h6>Devis personnalisé</h6>
                </div>
              </div>
              <div class="p-3">
                <div class="text-center mt-2">
                  <!-- CONTACT FORM-->
                  <form role="form" class="mx-3" @submit.prevent="callMeBack">
                    <input type="hidden" name="name" value="From myaccount premium page.">
                    <input type="hidden" name="email" value="unknown@bubbleplan.net">
                    <input type="hidden" name="subject" value="Call me back !">
                    <input type="text" name="message" placeholder="Téléphone" class="form-control form-control-lg" required>
                    <button class="mt-3 btn btn-dark btn-enterprise btn-cta btn-tada" type="submit">Être rappelé</button>
                    <div id="contactMsg" class="text-dark" style="display:none; margin-bottom:10px"></div>
                  </form>
                </div>
                <hr class="my-5 w-200 border-enterprise" style="border-top-width: 1px">
                <div class="mb-2 w-100">
                  <a href="mailto:contact@bubbleplan.net" target="_blank" class="btn btn-round btn-outline-dark btn-outline-enterprise">Nous contacter par e-mail</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .pricing-1 {
    border: none;
    border-radius: 12px;
  }
  .pricing-1 > div:first-child {
    border-radius: 12px 12px 0 0;
  }
  .pricing-1 .pricing-1-content {
    border-width: 1px;
    border-style: solid;
    border-top: none;
    border-radius: 0 0 12px 12px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
  .pricing-1:hover button.btn-tada {
      animation-name: tada;
      animation-duration: 1s;
      animation-fill-mode: both;
      animation-iteration-count: 1;
  }
</style>

<script>
  import apiSrv from '../apiSrv';
  import { printLang } from '../lang';

  // Lang
  window.jstexts = window.jstexts || {};
  Object.assign(window.jstexts, {
    MissingField: printLang('Contact.Validation.MissingField'),
    InvalidEmail: printLang('Contact.Validation.InvalidEmail'),
    MessageSent: printLang('Contact.Validation.MessageSent'),
    Error: printLang('Contact.Validation.Error'),
  });

  export default {
    props: {
      coupon: { type: String, default: '' },
    },
    data() {
      return {
        printLang,
        planPeriod: 'yearly',
        quantityUsersTeam: 10,
        quantityUsersBusiness: 10,
        couponIsAvailable: false, // no coupon available at the moment
        couponInput: '',
        couponInputBusiness: '',
      };
    },
    computed: {
      hasValidCoupon() {
        return this.coupon && ['BLACKFRIDAY'].includes(this.coupon) && this.planPeriod === 'yearly';
      },
    },
    created() {
      apiSrv.loadUser().then((user) => {
        this.quantityUsersTeam = user?.company?.users?.length || 10;
        this.quantityUsersBusiness = user?.company?.users?.length || 10;
      });
    },
    methods: {
      sendDataCheckout(target) {
        const thisform = $(target);
        window.location = `${printLang('Url')}?${thisform.serialize()}#checkout`;
      },
      callMeBack(event) {
        window.submitContactForm(event.target);
      },
    },
  };
</script>
